import { render } from "./TilesSelectTemplateSk.vue?vue&type=template&id=945f78b0&scoped=true"
import script from "./TilesSelectTemplateSk.vue?vue&type=script&lang=js"
export * from "./TilesSelectTemplateSk.vue?vue&type=script&lang=js"

import "./TilesSelectTemplateSk.vue?vue&type=style&index=0&id=945f78b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945f78b0"]])

export default __exports__